import { errorValidation } from './utils';

(() => {
    const $form = $("form[name='contact']");
    $form.validate({
        ignore: [],
        ...errorValidation,
        errorClass: 'label-error',
        rules: {
            'contact[name]': {
                required: true,
            },
            'contact[email]': {
                required: true,
                email: true,
            },
            'contact[message]': {
                required: true,
            },
        },
        messages: {
            'contact[name]': {
                required: window.translations.required,
            },
            'contact[email]': {
                required: window.translations.required,
                email: window.translations.emailInvalid,
            },
            'contact[message]': {
                required: window.translations.required,
            },
        },
        submitHandler: (form) => {
            form.submit();
        },
        success: function (label) {
            label.text('');
        },
    });
})();
